import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../../core/navbar.service';
import { SeoService } from '../../core/seo.service';
import { ContentfulService } from '../../core/contentful.service';
import { TIMELINE_ERAS, TIMELINE_EVENTS, TimelineEra, TimelineEvent } from './timeline.data';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css']
})
export class TimelineComponent implements OnInit {
  eras: TimelineEra[] = TIMELINE_ERAS;
  selectedEra: string = 'all';
  events: TimelineEvent[] = TIMELINE_EVENTS;
  filteredEvents: TimelineEvent[] = TIMELINE_EVENTS;
  activeEvent: TimelineEvent | null = null;

  constructor(
    public nav: NavbarService,
    private seo: SeoService,
    private contentful: ContentfulService
  ) {}

  ngOnInit(): void {
    this.nav.show();
    this.seo.updateTags({
      title: 'Interactive Historical Timeline: 300+ Years of Lacombe Heritage',
      description: 'Explore the interactive timeline of Bayou Lacombe and St. Tammany Parish: from ancient Choctaw shell mounds and French colonial brickmaking to Chahta-Ima, the 1912 wooden schoolhouse, and La Toussaint.',
      url: '/timeline'
    });

    // Attempt to load dynamic timeline entries from Contentful
    this.contentful.getTimelineEvents().then(entries => {
      if (entries && entries.length > 0) {
        this.events = entries.map(entry => {
          const f = entry.fields;
          return {
            year: f.year || '',
            title: f.title || '',
            era: f.era || 'indigenous',
            eraName: f.eraName || 'Historical Era',
            badge: f.badge || 'History',
            icon: f.icon || 'history_edu',
            summary: f.summary || '',
            description: f.description || '',
            significance: f.significance || '',
            imageUrl: f.image?.fields?.file?.url ? `https:${f.image.fields.file.url}` : undefined,
            imageCaption: f.imageCaption || ''
          };
        });
        this.filterByEra(this.selectedEra);
      }
    }).catch(() => {
      // Contentful model not yet published or empty, gracefully keep TIMELINE_EVENTS
    });
  }

  filterByEra(eraId: string): void {
    this.selectedEra = eraId;
    if (eraId === 'all') {
      this.filteredEvents = this.events;
    } else {
      this.filteredEvents = this.events.filter(e => e.era === eraId);
    }
  }

  selectEvent(event: TimelineEvent): void {
    this.activeEvent = this.activeEvent === event ? null : event;
  }
}
